import React, { useMemo, forwardRef } from 'react';
import './Timeline.css';

const SECTIONS_DATA = [
  { id: 1, start: 0, end: 33.33, colorClass: 'section-color-1' },
  { id: 2, start: 33.33, end: 66.66, colorClass: 'section-color-2' },
  { id: 3, start: 66.66, end: 100, colorClass: 'section-color-3' },
];

const Timeline = forwardRef((props, ref) => {
  
  const sections = useMemo(() => {
    return SECTIONS_DATA.map(section => ({
      ...section,
    }));
  }, []);

  return (
    <div className="timeline-container" ref={ref}>
    <div className="row-line line-1" />
    <div className="row-line line-2" />
    <div className="row-line line-3" />
      {sections.map((section, index) => ( 
        <div
          key={section.id}
          className={`timeline-clip clip-${index + 1} ${section.colorClass}`} 
          title={`Section ${section.id}`}
        >
        </div>
      ))}
      <div className="timeline-indicator"></div>
    </div>
  );
});

export default Timeline;